(function(){
  'use strict';

  // Mobile nav toggle
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-nav-toggle]');
    if(!t) return;
    var nav = document.querySelector('[data-nav]');
    if(nav) nav.classList.toggle('is-open');
  });

  // Image slider (PDP / landing hero)
  document.querySelectorAll('[data-slider]').forEach(function(slider){
    var track = slider.querySelector('[data-slider-track]');
    if(!track || track.children.length < 2) return;
    var slides = track.children;
    var dots = slider.querySelector('[data-slider-dots]');
    var idx = 0;

    function go(i){
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      if(dots){
        Array.prototype.forEach.call(dots.children, function(b, bi){
          b.classList.toggle('is-active', bi === idx);
        });
      }
    }

    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if(prev) prev.addEventListener('click', function(){ go(idx - 1); });
    if(next) next.addEventListener('click', function(){ go(idx + 1); });
    if(dots) dots.addEventListener('click', function(e){
      var b = e.target.closest('button[data-slider-go]');
      if(b) go(parseInt(b.getAttribute('data-slider-go'), 10));
    });

    // Touch swipe
    var startX = null, startY = null;
    slider.addEventListener('touchstart', function(e){
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    slider.addEventListener('touchend', function(e){
      if(startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
        go(dx < 0 ? idx + 1 : idx - 1);
      }
      startX = startY = null;
    }, { passive: true });

    // Keyboard nav
    slider.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft') go(idx - 1);
      if(e.key === 'ArrowRight') go(idx + 1);
    });
  });

  // Search overlay
  var searchOverlay = document.querySelector('[data-search-overlay]');
  function openSearch(){ if(searchOverlay){ searchOverlay.classList.add('is-open'); searchOverlay.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; var inp=searchOverlay.querySelector('input[name="q"]'); if(inp) setTimeout(function(){inp.focus();},50); } }
  function closeSearch(){ if(searchOverlay){ searchOverlay.classList.remove('is-open'); searchOverlay.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-search-open]')){ e.preventDefault(); openSearch(); }
    if(e.target.closest('[data-search-close]')) closeSearch();
    if(e.target === searchOverlay) closeSearch();
  });

  // Cart drawer
  var drawer = document.getElementById('CartDrawer');
  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-open]')){ e.preventDefault(); refreshCart(); openDrawer(); }
    if(e.target.closest('[data-cart-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeDrawer(); closeSearch(); } });

  // PDP gallery
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('[data-thumb]');
    if(!thumb) return;
    var src = thumb.getAttribute('data-thumb');
    var main = document.querySelector('[data-main-image]');
    if(main){ main.src = src; }
    document.querySelectorAll('[data-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  // Variant selectors (color / size)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-option]');
    if(!btn) return;
    var group = btn.getAttribute('data-option-group');
    document.querySelectorAll('[data-option-group="'+group+'"]').forEach(function(b){ b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    syncVariant();
  });

  function syncVariant(){
    var form = document.querySelector('[data-product-form]');
    if(!form) return;
    var selected = {};
    form.querySelectorAll('[data-option].is-active').forEach(function(b){
      selected[b.getAttribute('data-option-group')] = b.getAttribute('data-option');
    });
    var variants = window.__productVariants || [];
    var match = variants.find(function(v){
      return Object.keys(selected).every(function(k){
        return (v.options[k]||'').toLowerCase() === selected[k].toLowerCase();
      });
    });
    if(match){
      var input = form.querySelector('[name="id"]');
      if(input) input.value = match.id;
      var priceEl = document.querySelector('[data-product-price]');
      if(priceEl) priceEl.textContent = match.price;
    }
  }

  // Qty controls
  document.addEventListener('click', function(e){
    var minus = e.target.closest('[data-qty-minus]');
    var plus  = e.target.closest('[data-qty-plus]');
    if(!minus && !plus) return;
    var input = (minus||plus).parentNode.querySelector('input[name="quantity"]');
    if(!input) return;
    var v = parseInt(input.value||'1',10);
    input.value = Math.max(1, plus ? v+1 : v-1);
  });

  // Detect Buy now click before submit
  document.addEventListener('click', function(e){
    var bn = e.target.closest('[data-buy-now]');
    if(bn){ var f = bn.closest('form'); if(f) f.dataset.buyNow = '1'; }
  });

  // Add to cart (ajax) — supports both Add to cart and Buy now
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-product-form]');
    if(!form) return;
    e.preventDefault();
    var isBuyNow = form.dataset.buyNow === '1';
    var fd = new FormData(form);
    fetch('/cart/add.js', { method:'POST', body: fd, headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(){
        if(isBuyNow){ window.location.href = '/checkout'; return; }
        refreshCart();
        openDrawer();
      })
      .catch(function(){ window.location.href = isBuyNow ? '/checkout' : '/cart'; })
      .finally(function(){ delete form.dataset.buyNow; });
  });

  // Quantity update / remove inside drawer
  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-cart-remove]');
    if(!rm) return;
    e.preventDefault();
    var key = rm.getAttribute('data-cart-remove');
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id:key, quantity:0 })
    }).then(refreshCart);
  });

  function refreshCart(){
    fetch('/cart.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var body = document.querySelector('[data-cart-body]');
        var count = document.querySelector('[data-cart-count]');
        if(count) count.textContent = cart.item_count;
        if(!body) return;
        if(cart.item_count===0){
          body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
          return;
        }
        var html = cart.items.map(function(it){
          return '<div class="cart-line">'+
            '<div class="cart-line__img"><img src="'+it.image+'" alt="'+it.title+'"></div>'+
            '<div><p class="cart-line__title">'+it.product_title+'</p>'+
            '<p class="cart-line__meta">'+(it.variant_title||'')+' &middot; Qty '+it.quantity+'</p>'+
            '<a href="#" data-cart-remove="'+it.key+'" class="cart-line__meta">Remove</a></div>'+
            '<div class="cart-line__price">'+formatMoney(it.line_price)+'</div>'+
          '</div>';
        }).join('');
        html += '<div style="display:flex;justify-content:space-between;font-weight:700;padding-top:18px;margin-top:8px;border-top:1px solid #eee;font-size:1.05rem"><span>Subtotal</span><span>'+formatMoney(cart.total_price)+'</span></div>';
        body.innerHTML = html;
      });
  }
  function formatMoney(cents){ return '$'+(cents/100).toFixed(2); }

  // initial cart count
  if(document.querySelector('[data-cart-count]')) refreshCart();

})();
